import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';

const RateWarningLabel = <FormattedMessage {...messages.rateWarningLabel} />;

export default RateWarningLabel;
